function getScrollTop() {
  var scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0
  if (document.body) {
    bodyScrollTop = document.body.scrollTop
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop
  }
  scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
  return scrollTop
}

// 文档的总高度

function getScrollHeight() {
  var scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight
  }
  scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
  return scrollHeight
}

// 浏览器视口的高度

function getWindowHeight() {
  var windowHeight = 0
  if (document.compatMode === 'CSS1Compat') {
    windowHeight = document.documentElement.clientHeight
  } else {
    windowHeight = document.body.clientHeight
  }
  return windowHeight
}

function getWindowWidth() {
  var windowWidth = 0
  if (document.compatMode === 'CSS1Compat') {
    windowWidth = document.documentElement.clientWidth
  } else {
    windowWidth = document.body.clientWidth
  }
  return windowWidth
}

export const checkButtom = function () {
  // console.log(getScrollTop(), getWindowHeight(), getScrollHeight())
  if ((getScrollTop() + getWindowHeight()) >= (getScrollHeight() - 1)) {
    return true
  }
  return false
}
export default {
  checkButtom, getScrollTop, getWindowHeight, getScrollHeight, getWindowWidth
}



// WEBPACK FOOTER //
// src/helper/scroll.js